/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationChartPoint
 */
export interface EvaluationChartPoint {
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartPoint
     */
    recordName: string;
    /**
     * 
     * @type {number}
     * @memberof EvaluationChartPoint
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluationChartPoint
     */
    y: number;
}

/**
 * Check if a given object implements the EvaluationChartPoint interface.
 */
export function instanceOfEvaluationChartPoint(value: object): value is EvaluationChartPoint {
    if (!('recordName' in value) || value['recordName'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    return true;
}

export function EvaluationChartPointFromJSON(json: any): EvaluationChartPoint {
    return EvaluationChartPointFromJSONTyped(json, false);
}

export function EvaluationChartPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationChartPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'recordName': json['recordName'],
        'x': json['x'],
        'y': json['y'],
    };
}

export function EvaluationChartPointToJSON(value?: EvaluationChartPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'recordName': value['recordName'],
        'x': value['x'],
        'y': value['y'],
    };
}

